<script setup lang="ts">
import {
	symbol,
	symbolCircle,
	symbolCross,
	symbolDiamond,
	symbolSquare,
	symbolStar,
	symbolTriangle,
} from "d3";
import { computed } from "vue";
import type { LinePathStyle, PointShape } from "../../interfaces";

const props = defineProps<{
	value: LinePathStyle;
}>();

const isDoted = computed(() => props.value.lineDashStyle?.includes(10));
const dotStyle = computed(() => ({ color: `${props.value.color}` }));

const dash = computed(() => {
	if (!props.value.lineDashStyle) return "solid";
	return "dashed";
});

const lineStyle = computed(() => {
	const color = props.value.color;
	const lineWidth = props.value.lineWidth;

	return {
		borderTop: `${lineWidth}px ${dash.value} ${color}`,
		width: `17px`,
	};
});

const getSymbol = (shape: PointShape) => {
	switch (shape) {
		case "circle":
			return symbolCircle;
		case "square":
			return symbolSquare;
		case "cross":
			return symbolCross;
		case "triangle":
			return symbolTriangle;
		case "star":
			return symbolStar;
		case "diamond":
			return symbolDiamond;
		default:
			return symbolCircle;
	}
};

const d3SymbolPath = (size: number) => {
	const selectedSymbol = getSymbol(props.value.point.shape);
	if (!size) size = 3;

	return (
		symbol()
			.type(selectedSymbol)
			.size(50 + 3 ** size)() || ""
	);
};

const point = computed(() => {
	const color = props.value.color;
	const _x = 10;
	const _y = 10;

	const pointsIdSet = new Set<string>();
	const point = {
		id: pointsIdSet,
		_x,
		_y,
		d: d3SymbolPath(props.value.point.size) || "",
		// d: d3SymbolPath(lineWidth) || "",
		transform: `translate(${_x}, ${_y})`,
		fill: color,
		opacity: null,
	};

	return point;
});
</script>

<template>
	<div class="w-6">
		<div class="relative flex justify-center">
			<svg v-if="value.point.visible" width="20" height="20">
				<g>
					<path v-bind="point as any" />
				</g>
			</svg>
			<div v-else-if="isDoted" class="flex justify-start" :style="dotStyle">•••</div>
			<div v-else class="flex justify-start" :style="lineStyle"></div>
		</div>
	</div>
</template>
